export default "__VITE_ASSET__Da63wxow__"